import { gql, useQuery } from '@apollo/client'
import {
  ViewRecoveryCertificateQuery,
  ViewRecoveryCertificateQueryVariables,
} from '../../../pages/__generated__/ViewRecoveryCertificateQuery'
import { RecoveryCertificateQuery_recoveryCertificates } from './__generated__/RecoveryCertificateQuery'

export const recoveryCertificateDetailsQuery = gql`
  query PreviewRecoveryCertificateQuery($orderId: ID!) {
    recoveryCertificateDetails(orderId: $orderId) {
      orderId
      firstName
      lastName
      dateOfBirth
      passportNumber
      positiveCovidTestDate
      typeOfCovidTest
      lastTimeExperiencedSymptoms
      approvedAt
      certificateFile
      success
    }
  }
`

export const PreviewRecoveryCertificate = ({
  orderId,
}: {
  orderId: RecoveryCertificateQuery_recoveryCertificates['orderId']
}) => {
  const { data, loading } = useQuery<ViewRecoveryCertificateQuery, ViewRecoveryCertificateQueryVariables>(
    recoveryCertificateDetailsQuery,
    {
      variables: { orderId },
      fetchPolicy: 'no-cache',
    }
  )

  if (loading || !data) {
    return <p>Loading...</p>
  }

  return (
    <>
      <object
        data={`data:application/pdf;base64,${data?.recoveryCertificateDetails?.certificateFile}`}
        type="application/pdf"
        width="100%"
        height="1400"
      >
        <p>Loading Recovery Certificate</p>
      </object>
    </>
  )
}

export default PreviewRecoveryCertificate
